import { ShoppingCart } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";
import { useMemo } from "react";
import './CheckoutButton.scss';

export default function CheckoutButton(props:{onClick: () => void, disabled?: boolean, textKey?: string}) {
  const { themeClass } = useThemeService();
  const textKey = useMemo(() => props.textKey ? props.textKey : "shop.checkout", [props.textKey])

  return (
    <Button
        id="checkout-button"
        onClick={props.onClick}
        disabled={props.disabled}
        icon={{
          svg: ShoppingCart,
          textKey: textKey,
          className: themeClass(["icon-custom"]),
        }}
        className={themeClass(["btn-huge", "run-ai-button"])}
      />
  )
}
